import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-genome',
  templateUrl: './my-genome.component.html',
  styleUrls: ['./my-genome.component.scss']
})
export class MyGenomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
